exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.content-wrapper[data-v-93b51a9a] {\n    display: flex;\n    align-items: flex-start;\n    flex-wrap: wrap;\n    min-height: 100vh;\n}\n", ""]);

// exports
